export const BillToCompanyMappingConstant = {
    Table: {
        PRIORITY: "Priority",
        CHARGE_TYPE: "Charge Type",
        OPERATING_TML: "Operating Tml",
        CONTAINER_STATUS: "Container Status",
        SUB_CHARGE_TYPE: "Sub Charge Type",
        BILLTO_COMPANY: "Bill-To Company",
        SOA: "SOA",
        OPS_LINE: "Ops Line",
        FORWARDER_CODE: "Forwarder/Shipper/Consignee",  //update by betty
        FORWARDER_REF: "Forwarder Ref",
        VESSEL_TYPE: "Vessel Type",
        CHARGE_CODE: "Physical Handling Code",  //update by betty
        CONSORTIUM: "Consortium",
        SERVICE: "Service",
        ACTIVE_IND: "Active Ind.",
    },
    Title: {
        CATEGORY: "Charge",
        TITLE: "Bill-To Company Setting",
        MAPPING_FROM: "From",
        MAPPING_TO: "To",
    }
}

export const billToCompanyMappingRequiredFieldList: string[] = [
    'billToCompanyCode',
    'activeInd',
];
